// extracted by mini-css-extract-plugin
export default {"card":"s3-z"};